import { useEffect, useState } from "react";
import type { RefObject } from "react";

/** Load decorative engines once near the viewport; existing owners still pause ticks. */
export function useScenePreload(sceneRef: RefObject<HTMLElement | null>) {
  const [requested, setRequested] = useState(typeof IntersectionObserver === "undefined");
  useEffect(() => {
    const scene = sceneRef.current;
    if (!scene || typeof IntersectionObserver === "undefined") return;
    let near = false;
    const request = () => {
      if (!near || document.visibilityState === "hidden") return;
      setRequested(true);
      observer.disconnect();
      document.removeEventListener("visibilitychange", request);
    };
    const observer = new IntersectionObserver((entries) => {
      const entry = entries.find((item) => item.target === scene);
      if (entry) near = entry.isIntersecting;
      request();
    }, { rootMargin: "200px 0px" });
    observer.observe(scene);
    document.addEventListener("visibilitychange", request);
    return () => {
      observer.disconnect();
      document.removeEventListener("visibilitychange", request);
    };
  }, [sceneRef]);
  return requested;
}
